export default "__VITE_ASSET__DxZXO0im__"